import { Flex, Grid } from 'components/box';
import FormError from 'components/form/error';
import FacebookAuthentication from 'components/_shared/widgets/facebook-authentication';
import GoogleAuthentication from 'components/_shared/widgets/google-authentication';
import { useState } from 'react';
import { AuthenticationContext } from 'types/types';

/**
 * NOTE: the new google identity services have strict limitations on button sizing.
 * We can no longer give it a responsive width.
 * To accommodate for that in our design, we have a centered grid,
 * with 1 column 2 rows on mobile, and 2 columns 1 row on tablet upwards.
 * And we have a hardcoded height and overflow hidden to reduce flicker.
 */
const SocialAuth = ({ context }: { context: AuthenticationContext }) => {
  const [error, setError] = useState<string | undefined>();

  return (
    <Flex alignItems="center" flexDirection="column" justifyContent="center">
      <Grid
        gridTemplateColumns={['auto', '1fr 1fr']}
        height={['125px', '62px']}
        pb="2px"
        overflow="hidden"
        width="100%"
      >
        <GoogleAuthentication context={context} setError={setError} />
        <FacebookAuthentication context={context} setError={setError} />
      </Grid>

      {error && <FormError textAlign="center">{error}</FormError>}
    </Flex>
  );
};

export default SocialAuth;
